import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { action, observable, reaction } from 'mobx';
import { findInArray, sortArray } from 'utils/helpers';
import { COUNTRIES } from 'config/constants';

import SidebarItem from './SidebarItem';

import { Loader, CountriesDropdown, Search } from 'ui/components';

import './Sidebar.scss';

@inject('ProductsState', 'AppState', 'UIState')
@observer
export default class Sidebar extends Component {
	static propTypes = {
		ProductsState: PropTypes.object.isRequired,
		AppState: PropTypes.object.isRequired,
		UIState: PropTypes.object.isRequired,
	};

	componentWillMount() {
		this.ProductsState.fetchPromotions();

		reaction(
			() => this.props.UIState.selectedPromotion,
			result => this.selectPromotionInMenu(result)
		);
	}

	@action
	componentDidUpdate() {
		if (this.countryChanged) {
			const promotion = this.UIState.selectedPromotion;
			this.findAndSelect(promotion);
		}
	}

	ProductsState = this.props.ProductsState;
	UIState = this.props.UIState;

	@observable showCountries = false;
	@observable selectedCountry = '';
	@observable country = null;

	resetPromotionsState() {
		this.UIState.resetPromotionState();
		this.countryChanged = false;
	}

	findAndSelect(promotion) {
		findInArray(this.UIState.promotions, promotion.promo_id, 'id').expand(true);

		findInArray(this.UIState.categories, promotion.category_id, 'id').select(
			true
		);
	}

	selectPromotionInMenu(promotion) {
		this.promotion = findInArray(
			this.UIState.promotions,
			promotion.promo_id,
			'id'
		);

		if (!this.promotion) {
			this.handleCountryChange(
				findInArray(
					this.ProductsState.fetchPromotions.state.result,
					COUNTRIES[promotion.country_short_name],
					'name'
				)
			);
			this.countryChanged = true;

			return;
		}
		this.findAndSelect(promotion);
	}

	@action
	toggle() {
		this.showCountries = !this.showCountries;
	}

	@action
	handleCountryChange(country) {
		if (this.selectedCountry !== country.name) {
			this.resetPromotionsState();
			this.promotions = country.promotions
				? sortArray(country.promotions, 'name')
				: [];
			this.selectedCountry = country.name ? country.name : country;
		}
	}

	render() {
		const { fetchPromotions } = this.props.ProductsState;
		const userCountryName = this.props.AppState.user.country.long_name;

		return (
			<div className="Sidebar">
				<Search leftSide iconButton />
				{fetchPromotions.handle({
					loading: () => <Loader />,
					rejected: () => <div className="Error__not-available" />,
					resolved: result => {
						const userCountry = findInArray(result, userCountryName, 'name');

						const promos = userCountry
							? result
							: [...result, ...[{ name: userCountryName }]];

						return (
							<div className="Sidebar__content">
								{!this.selectedCountry &&
									this.handleCountryChange(userCountry || userCountryName)}

								<div className="Sidebar__content__country">
									{promos[0].isGeneric
										? userCountryName
										: <CountriesDropdown
												countries={promos}
												toggle={this.toggle.bind(this)}
												selectedCountry={this.selectedCountry}
												expanded={this.showCountries}
												countryChange={this.handleCountryChange.bind(this)}
											/>}
								</div>

								<div id="SidebarPromotionsList">
									{this.promotions.map(item =>
										<SidebarItem key={item.id} promo={item} />
									)}
								</div>
							</div>
						);
					},
				})}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Sidebar/index.js